<div class="flex align-items-center">
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-chevron-left"
    class="p-button-primary p-button-sm p-button-rounded p-button-text"
    (click)="onPrev()"
    [disabled]="isPrevDisabled"
  ></button>
  <span class="font-semibold mx-1">{{ value }}</span>
  <button
    pButton
    pRipple
    type="button"
    icon="pi pi-chevron-right"
    class="p-button-primary p-button-sm p-button-rounded p-button-text"
    (click)="onNext()"
    [disabled]="isNextDisabled"
  ></button>
</div>
